// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArchiveToggleController from "./archive_toggle_controller"
application.register("archive-toggle", ArchiveToggleController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import AnswerSyncController from "./answer_sync_controller"
application.register("answer-sync", AnswerSyncController)

import BookDescriptionController from "./book_description_controller"
import CategoryTabsController from "./category_tabs_controller"
application.register("book-description", BookDescriptionController)
application.register("category-tabs", CategoryTabsController)

import FlashContainerController from "./flash_container_controller"
application.register("flash-container", FlashContainerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReadButtonController from "./read_button_controller"
application.register("read-button", ReadButtonController)

import ScrollToActiveController from "./scroll_to_active_controller"
application.register("scroll-to-active", ScrollToActiveController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ReadingStatusController from "./reading_status_controller"
application.register("reading-status", ReadingStatusController)

import StoryReadingController from "./story_reading_controller"
application.register("story-reading", StoryReadingController)

import NewsletterPickupsController from "./newsletter_pickups_controller"
application.register("newsletter-pickups", NewsletterPickupsController)

import ArticleSearchController from "./article_search_controller"
application.register("article-search", ArticleSearchController)
